<template>
    <div class="deposit-modal">
        <!-- Display the custom game creation modal if not loading -->
        <modal class="style-modal-deposit" @close-modal="closeModal">
            <main class="mt-1">
                <div class="container overflow: hidden px-0">
                    <div class="deposit-container px-3 py-4">
                        <!-- Wallet nav: segmented Deposit | Withdraw toggle. Opens on
                             Deposit; tapping Withdraw navigates to the withdraw modal.
                             The modal content below is otherwise unchanged. -->
                        <div v-if="canUseCashier" class="wallet-tabs">
                            <button type="button" class="wallet-tab wallet-tab--active">Deposit</button>
                            <button type="button" class="wallet-tab" @click="switchToWithdraw">Withdraw</button>
                        </div>
                        <div class="row mx-0">
                            <div class="col-8 row align-items-center mx-0 flex-nowrap">
                                <img src="../../../public/images/lightningSquare.svg" class="wallet-header-icon mr-3 ml-0" />
                                <div class="wallet-header-text">
                                    <label class="deposit-label-1">Deposit Crypto</label>
                                    <label class="deposit-label-2">No Limit</label>
                                </div>
                            </div>
                            <div class="col-4 icons-container-aligment">
                                <div class="icons-container-aligment-item">
                                    <font-awesome-icon
                                        :icon="faBitcoin"
                                        class="mr-2 ml-0 font-weight-light bitcoinIcon"
                                        color="#f7931a"
                                    />
                                    <img
                                        :src="`/icons/usdt.png`"
                                        class="mr-2 ml-0 logosCoin"
                                    />
                                    <img
                                        :src="`/icons/usdc.png`"
                                        class="mr-2 ml-0 logosCoin"
                                        />
                                    <img
                                        :src="`/icons/ethereum.png`"
                                        class="mr-2 ml-0 logosCoin"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="row mx-0 pt-4 pb-3">
                            <div class="col-6 pr-2">
                                <label class="deposit-label-2">Supported Token</label>
                                <div v-click-outside="() => isOpen1 = false" class="dropdown-wrapper">
                                    <button class="dropdown" :class="{ 'dropdown-open': isOpen1 }" @click="isOpen1 = !isOpen1" :disabled="showPendingDeposit">
                                        <div class="dropdown-button">
                                            <div class="dropdown-selected">
                                                <font-awesome-icon
                                                    v-if="supportedTokenValue.name === 'BITCOIN'"
                                                    :icon="faBitcoin"
                                                    class="dropdown-icon bitcoinIcon"
                                                    color="#f7931a"
                                                />
                                                <img
                                                    v-else
                                                    :src="`/icons/${supportedTokenValue.name.toLowerCase()}.png`"
                                                    class="dropdown-icon logosCoin"
                                                />
                                                <span>{{ formatTokenName(supportedTokenValue.name) }}</span>
                                            </div>
                                            <font-awesome-icon :icon="faChevronDown" class="dropdown-chevron" :class="{ 'chevron-up': isOpen1 }" />
                                        </div>
                                    </button>
                                    <transition name="dropdown-fade">
                                        <div v-if="isOpen1" class="dropdown-content">
                                            <a v-for="token in supportedToken" :key="token.id" @click="changeSupportedToken(token)" class="dropdown-item" :class="{ 'dropdown-item-selected': token.name === supportedTokenValue.name }">
                                                <font-awesome-icon
                                                    v-if="token.name === 'BITCOIN'"
                                                    :icon="faBitcoin"
                                                    class="dropdown-icon bitcoinIcon"
                                                    color="#f7931a"
                                                />
                                                <img
                                                    v-else
                                                    :src="`/icons/${token.name.toLowerCase()}.png`"
                                                    class="dropdown-icon logosCoin"
                                                />
                                                <span>{{ formatTokenName(token.name) }}</span>
                                            </a>
                                        </div>
                                    </transition>
                                </div>
                            </div>  
                            <div class="col-6 pl-2">
                                <label class="deposit-label-2">Supported Chain</label>
                                <div v-click-outside="() => isOpen2 = false" class="dropdown-wrapper">
                                    <button class="dropdown" :class="{ 'dropdown-open': isOpen2 }" @click="isOpen2 = !isOpen2" :disabled="showPendingDeposit">
                                        <div class="dropdown-button">
                                            <div class="dropdown-selected">
                                                <font-awesome-icon
                                                    v-if="supportedChainValue.name === 'BITCOIN'"
                                                    :icon="faBitcoin"
                                                    class="dropdown-icon bitcoinIcon"
                                                    color="#f7931a"
                                                />
                                                <img
                                                    v-else
                                                    :src="`/icons/${supportedChainValue.name.toLowerCase()}.png`"
                                                    class="dropdown-icon logosCoin"
                                                />
                                                <span>{{ formatTokenName(supportedChainValue.name) }}</span>
                                            </div>
                                            <font-awesome-icon :icon="faChevronDown" class="dropdown-chevron" :class="{ 'chevron-up': isOpen2 }" />
                                        </div>
                                    </button>
                                    <transition name="dropdown-fade">
                                        <div v-if="isOpen2" class="dropdown-content">
                                            <a v-for="chain in filteredSupportedChain(supportedTokenValue.name)" :key="chain.id" @click="supportedChainUpdate(chain)" class="dropdown-item" :class="{ 'dropdown-item-selected': chain.name === supportedChainValue.name }">
                                                <font-awesome-icon
                                                    v-if="chain.name === 'BITCOIN'"
                                                    :icon="faBitcoin"
                                                    class="dropdown-icon bitcoinIcon"
                                                    color="#f7931a"
                                                />
                                                <img
                                                    v-else
                                                    :src="`/icons/${chain.name.toLowerCase()}.png`"
                                                    class="dropdown-icon logosCoin"
                                                />
                                                <span>{{ formatTokenName(chain.name) }}</span>
                                            </a>
                                        </div>
                                    </transition>
                                </div>
                            </div>  
                        </div>
                        <div v-if="!showPendingDeposit" class="mt-3">
                            <div class="col-12 mb-3">
                                <label class="deposit-label-2">Transfer Amount (USD)</label>
                                <div class="deposit-input-container">
                                    <div class="input-with-prefix">
                                        <span class="input-prefix">$</span>
                                        <input 
                                            class="deposit-input deposit-input--with-prefix" 
                                            type="number" 
                                            v-model="depositAmount" 
                                            placeholder="0.00"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 mb-3">
                                <div class="deposit-button-container">
                                    <button class="deposit-button" @click="requestDeposit()">
                                        <font-awesome-icon :icon="faWallet" class="mr-2" />
                                        Generate Deposit Address
                                    </button>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="deposit-info-box">
                                    <div class="deposit-info-item">
                                        <font-awesome-icon :icon="faCircleCheck" class="deposit-info-icon deposit-info-icon--success" />
                                        <span>No minimum deposit</span>
                                    </div>
                                    <div class="deposit-info-item">
                                        <font-awesome-icon :icon="faCircleCheck" class="deposit-info-icon deposit-info-icon--success" />
                                        <span>Instant credit after confirmation</span>
                                    </div>
                                    <div class="deposit-info-item">
                                        <font-awesome-icon :icon="faShieldHalved" class="deposit-info-icon deposit-info-icon--secure" />
                                        <span>Secure & encrypted transactions</span>
                                    </div>
                                </div>
                                <button v-if="!showRequestForm && !requestSent" class="request-method-button" @click="showRequestForm = true">
                                    <font-awesome-icon :icon="faCommentDots" class="mr-2" />
                                    Don't see your method? Request one
                                </button>
                                <div v-if="showRequestForm && !requestSent" class="request-method-form">
                                    <input class="deposit-input mb-2" type="text" v-model="requestMethodText" placeholder="Which deposit method would you like?" maxlength="200" />
                                    <div class="deposit-button-container">
                                        <button class="deposit-button request-send-button" :disabled="requestSending" @click="requestDepositMethod()">
                                            <font-awesome-icon :icon="faPaperPlane" class="mr-2" />
                                            Send Request
                                        </button>
                                    </div>
                                    <span class="request-form-cancel" @click="showRequestForm = false">Cancel</span>
                                </div>
                                <div v-if="requestSent" class="request-sent-state">
                                    <font-awesome-icon :icon="faCircleCheck" />
                                    <span>
                                        <span class="request-sent-title">Request Sent</span>
                                        <span class="request-sent-detail">We'll Consider Adding Popular Requests</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div v-else class="mt-3">
                            <div class="col-12 mb-3 qrcode-container" v-if="showPendingDeposit">
                                <div class="qrcode-wrapper">
                                    <qrcode-vue :value="userStore.transactions.pendingDeposits[0].depositAddress.address" :size="120" level="H" render-as="svg" />
                                </div>
                                <p class="qrcode-hint">Scan to get deposit address</p>
                            </div>
                            <!-- Amount to Send - commented out for now
                            <div class="col-12 mb-3">
                                <label class="deposit-label-2">
                                    <font-awesome-icon :icon="faDollarSign" class="mr-1" />
                                    Amount to Send (USD)
                                </label>
                                <div class="deposit-input-container">
                                    <div class="pending-value-display">
                                        <span class="pending-value-prefix">$</span>
                                        <span class="pending-value-amount">{{ userStore.transactions.pendingDeposits[0].amount.$numberDecimal }}</span>
                                    </div>
                                </div>
                            </div>
                            -->
                            <div class="col-12 mb-3">
                                <label class="deposit-label-2">
                                    <font-awesome-icon :icon="faLocationDot" class="mr-1" />
                                    Send <strong class="deposit-amount-highlight">${{ formatAmount(userStore.transactions.pendingDeposits[0].amount) }}</strong> To This Address
                                    <span class="click-to-copy-hint">(click to copy)</span>
                                </label>
                                <div 
                                    class="address-copyable" 
                                    @click="copy(userStore.transactions.pendingDeposits[0].depositAddress.address, 'address')"
                                >
                                    <span class="address-text">{{ userStore.transactions.pendingDeposits[0].depositAddress.address }}</span>
                                    <font-awesome-icon :icon="faCopy" class="address-copy-icon" />
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="deposit-button-container mb-2">
                                    <button class="sent-button" @click="markAsSent(userStore.transactions.pendingDeposits[0]._id)" :disabled="userStore.transactions.pendingDeposits[0].userMarkedAsSent">                                                        
                                        <font-awesome-icon :icon="faCheck" class="mr-2" />
                                        {{ userStore.transactions.pendingDeposits[0].userMarkedAsSent ? 'Marked As Sent' : 'Mark As Sent' }}
                                    </button>
                                </div>
                                <div class="deposit-button-container">
                                    <button class="cancel-button" @click="cancelDeposit(userStore.transactions.pendingDeposits[0]._id)">
                                        Cancel Deposit Request
                                    </button>
                                </div>
                                <button v-if="!showRequestForm && !requestSent" class="request-method-button" @click="showRequestForm = true">
                                    <font-awesome-icon :icon="faCommentDots" class="mr-2" />
                                    Don't see your method? Request one
                                </button>
                                <div v-if="showRequestForm && !requestSent" class="request-method-form">
                                    <input class="deposit-input mb-2" type="text" v-model="requestMethodText" placeholder="Which deposit method would you like?" maxlength="200" />
                                    <div class="deposit-button-container">
                                        <button class="deposit-button request-send-button" :disabled="requestSending" @click="requestDepositMethod()">
                                            <font-awesome-icon :icon="faPaperPlane" class="mr-2" />
                                            Send Request
                                        </button>
                                    </div>
                                    <span class="request-form-cancel" @click="showRequestForm = false">Cancel</span>
                                </div>
                                <div v-if="requestSent" class="request-sent-state">
                                    <font-awesome-icon :icon="faCircleCheck" />
                                    <span>
                                        <span class="request-sent-title">Request Sent</span>
                                        <span class="request-sent-detail">We'll Consider Adding Popular Requests</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </modal>
    </div>
</template>
  
<script setup>
import { ref, onMounted, computed } from 'vue';
import { useAPI } from '@/composables/useAPI';
import Modal from '@/components/global/Modal.vue';
import Swal from 'sweetalert2';
import { emitter } from '@/core/emitter.js';
import { useUserStore } from '@/stores/user';
import { PostHogUtils } from '@/core/PostHogUtils';
import { userCanUseCashier } from '@/consts/constants';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faBitcoin } from '@fortawesome/free-brands-svg-icons/faBitcoin';
import { faPaste } from '@fortawesome/free-solid-svg-icons/faPaste';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown';
import { faWallet } from '@fortawesome/free-solid-svg-icons/faWallet';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons/faCircleCheck';
import { faShieldHalved } from '@fortawesome/free-solid-svg-icons/faShieldHalved';
import { faDollarSign } from '@fortawesome/free-solid-svg-icons/faDollarSign';
import { faLocationDot } from '@fortawesome/free-solid-svg-icons/faLocationDot';
import { faCopy } from '@fortawesome/free-solid-svg-icons/faCopy';
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';
import { faCommentDots } from '@fortawesome/free-solid-svg-icons/faCommentDots';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons/faPaperPlane';
import {
  depositRequestSuccess,
  depositRequestFail,
  depositMethodRequestSuccess,
  depositMethodRequestFail,
  cancelDepositRequestSuccess,
  cancelDepositRequestFail,
  markAsSentSuccess,
  markAsSentFail,
} from '@/core/notifications';
import { capitalize } from '@/core/utils';
import QrcodeVue, { QrcodeCanvas, QrcodeSvg } from 'qrcode.vue'
const { request: getDepositRequest } = useAPI('deposit/requestDeposit/');
const { request: markAsSentRequest } = useAPI('deposit/markAsSent/');
const { request: cancelDepositRequest } = useAPI(
  'deposit/cancelDepositRequest/',
);
const { request: requestDepositMethodApi } = useAPI(
  'deposit/requestDepositMethod/',
);
const userStore = useUserStore();
// Withdraw tab is gated to cashier-eligible users (blocked codes can't withdraw).
const canUseCashier = computed(() => userCanUseCashier(userStore.user));
const isOpen1 = ref(false);
const isOpen2 = ref(false);
const supportedTokenValue = ref({ name: 'BITCOIN', key: 'btc', id: '1' });
const supportedChainValue = ref({ name: 'BITCOIN', key: 'btc', id: '1' });
const depositAmount = ref('');
const showRequestForm = ref(false);
const requestMethodText = ref('');
const requestSent = ref(false);
const requestSending = ref(false);
const supportedToken = ref([
    { name: 'BITCOIN', key: 'btc', id: '1' },
    { name: 'USDT', key: 'usdt', id: '2' },
    { name: 'USDC', key: 'usdc', id: '3' },
    { name: 'ETHEREUM', key: 'eth', id: '4' },
]);
// Click outside directive
const vClickOutside = {
  mounted(el, binding) {
    el._clickOutside = (e) => {
      if (!el.contains(e.target)) binding.value(e);
    };
    document.addEventListener('click', el._clickOutside);
  },
  unmounted(el) {
    document.removeEventListener('click', el._clickOutside);
  },
};

const showPendingDeposit = computed(() => {
  return userStore.transactions.pendingDeposits &&
    userStore.transactions.pendingDeposits.length > 0
    ? true
    : false;
});

function closeModal() {
    emitter.emit('showDepositModal');
}

// Deposit -> withdraw tab switch: deterministically open withdraw + close deposit
// (no toggles — can't accidentally close both, and skips the deposit KYC gate).
function switchToWithdraw() {
    emitter.emit('walletSwitchToWithdraw');
}

function changeSupportedToken(token) {
    supportedTokenValue.value = token;
    if (supportedTokenValue.value.name === 'BITCOIN') {
        supportedChainValue.value = { name: 'BITCOIN', key: 'btc', id: '1' };
    } else if (supportedTokenValue.value.name === 'USDT' || supportedTokenValue.value.name === 'USDC' || supportedTokenValue.value.name === 'ETHEREUM') {
        supportedChainValue.value = { name: 'ETHEREUM', key: 'eth', id: '1' };
    }
    filteredSupportedChain(supportedTokenValue.value.name);
    isOpen1.value = false;
    isOpen2.value = false;
}

function filteredSupportedChain(supportedTokenName) {
    switch (supportedTokenName) {
        case 'BITCOIN':
            return [
                { name: 'BITCOIN', key: 'btc', id: '1' }
            ];
        case 'USDT':
            return [
                { name: 'ETHEREUM', key: 'eth', id: '1' }
            ];
        case 'USDC':
            return [
                { name: 'ETHEREUM', key: 'eth', id: '1' }
            ];
        case 'ETHEREUM':
            return [
                { name: 'ETHEREUM', key: 'eth', id: '1' },
            ];
    }
}

function formatTokenName(name) {
    // Keep USDT, USDC as all caps, capitalize others
    if (name === 'USDT' || name === 'USDC') {
        return name;
    }
    return capitalize(name.toLowerCase());
}

function formatAmount(amount) {
    // Handle MongoDB Decimal128 format
    const value = amount?.$numberDecimal ?? amount;
    const num = parseFloat(value);
    if (isNaN(num)) return '0.00';
    return num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

function supportedChainUpdate(chain) {
    supportedChainValue.value = chain;
    isOpen1.value = false;
    isOpen2.value = false;
}

async function copy(value, type) {
  const activeClass = { copy: 'copyactive', paste: 'pasteactive' };
  const doneMessage = { copy: 'copied', paste: 'pasted' };
  const doneClass = 'done';
  const body = document && document.body;
  let msg = '';
  // clipboard API available?
  if (!body || !navigator.clipboard) {
    return;
  }
  // text copy active
  if (navigator.clipboard.writeText) {
    body.classList.add(activeClass.copy);
    if (type === 'email' || type === 'telegram') {
      msg =
        type === 'email'
          ? 'Email successfully copied'
          : 'Telegram handle successfully copied';
    } else {
      msg =
        type === 'address'
          ? 'Address successfully copied'
          : 'Amount successfully copied';
    }
    emitter.emit('showAlert', {
      shown: true,
      status: 'ok',
      title: msg,
      detail: '',
    });
  }
  navigator.clipboard.writeText(value);
}

async function requestDeposit() {
  if (!depositAmount.value) {
    emitter.emit('showAlert', {
      type: 'submit-edit-order',
      shown: true,
      status: 'warning',
      title: 'Error',
      detail: 'You must enter a valid amount',
    });
  } else {
    const result = await Swal.fire({
      html: '<h4>Are you sure you want to submit this deposit request?</h4>',
      showCancelButton: true,
      confirmButtonText: 'Submit',
      confirmButtonColor: '#6f75b1',
    });
    if (result.isConfirmed) {
      try {
        // loading.value = true;
        await getDepositRequest({
          amount: depositAmount.value,
          token: supportedTokenValue.value,
          chain: supportedChainValue.value,
        });
        await userStore.getTransactions();
        // loading.value = false;
        PostHogUtils.capture('deposit_requested', {
          token: supportedTokenValue.value?.name,
          chain: supportedChainValue.value?.name,
        });
        depositRequestSuccess();
      } catch (error) {
        // loading.value = false;
        depositRequestFail(error);
      } finally {
        // loading.value = false;
      }
    }
  }
}

async function requestDepositMethod() {
  if (requestSending.value) return;
  const method = requestMethodText.value.trim();
  if (!method) {
    emitter.emit('showAlert', {
      type: 'submit-edit-order',
      shown: true,
      status: 'warning',
      title: 'Error',
      detail: 'Please enter a deposit method',
    });
    return;
  }
  requestSending.value = true;
  try {
    await requestDepositMethodApi({ method });
    requestSent.value = true;
    showRequestForm.value = false;
    depositMethodRequestSuccess();
  } catch (error) {
    depositMethodRequestFail(error?.message || 'Please try again later');
  } finally {
    requestSending.value = false;
  }
}

async function cancelDeposit(depositRequestID) {
  const result = await Swal.fire({
    html: '<h4>Are you sure you want to cancel the deposit request?</h4>',
    showCancelButton: true,
    confirmButtonText: 'Yes',
    confirmButtonColor: '#6f75b1',
  });
  if (result.isConfirmed) {
    try {
    //   loading.value = true;
      await cancelDepositRequest({
        depositRequestID: depositRequestID,
      });
      await userStore.getTransactions();
    //   loading.value = false;
      cancelDepositRequestSuccess();
    } catch (error) {
    //   loading.value = false;
      cancelDepositRequestFail(error);
    }
  }
}

async function markAsSent(depositRequestID) {
  const result = await Swal.fire({
    html: '<h4>Did you send the deposit? If so, notify an admin by pressing submit.</h4>',
    showCancelButton: true,
    confirmButtonText: 'Submit',
    confirmButtonColor: '#6f75b1',
  });
  if (result.isConfirmed) {
    try {
      await markAsSentRequest({
        depositRequestID,
      });
      // `source` tells the four components that fire this event apart — without
      // it the cashier surfaces are indistinguishable in analytics.
      PostHogUtils.capture('deposit_marked_sent', { source: 'deposit_modal' });
      // Durable person flag so we can segment depositors vs non-depositors
      // (and compute new-user → deposit conversion) without re-deriving from events.
      PostHogUtils.syncSettings({ has_ever_deposited: true });
      await userStore.getTransactions();
      markAsSentSuccess();
    } catch (error) {
      markAsSentFail(error);
    }
  }
}

//HOOKS
onMounted(async () => {
  PostHogUtils.capture('deposit_modal_opened');
  await userStore.getTransactions();
    const depositAddress = userStore.transactions.pendingDeposits?.[0]?.depositAddress;
    if (depositAddress) {
        if (depositAddress.token) {
            supportedTokenValue.value = supportedToken.value.find(token => token.key === depositAddress.token);
        }
        if (depositAddress.blockchain) {
            supportedChainValue.value = supportedToken.value.find(chain => chain.key === depositAddress.blockchain);
        }
    }
});
</script>
  
<style scoped lang="scss">
  @use 'sass:map';
  @use '@/scss/theme/variables.scss' as theme;
  
.deposit-container{
    // Wallet palette — keep in sync with WithdrawModal.vue so the two tabs of
    // the wallet modal read as one surface. Light values here, night below.
    --wallet-accent: #343b86;
    --wallet-accent-deep: #262c66;
    --wallet-accent-soft: #6f75b1;
    --wallet-muted: #6e739b;
    --wallet-text-soft: #565c82;
    --wallet-card-bg: #f4f5fa;
    --wallet-chip-bg: rgba(52, 59, 134, 0.08);
    --wallet-chip-bg-hover: rgba(52, 59, 134, 0.16);
    --wallet-ring: rgba(52, 59, 134, 0.14);
    --wallet-track-bg: rgba(52, 59, 134, 0.07);

    background-color: var(--wallet-card-bg);
    border-radius: 12px;

    [theme='night'] & {
        --wallet-accent: #6e76c8;
        --wallet-accent-deep: #4d56ab;
        --wallet-accent-soft: #969ccb;
        --wallet-muted: #9aa0c3;
        --wallet-text-soft: #b6bad4;
        --wallet-card-bg: var(--grey-1600);
        --wallet-chip-bg: rgba(150, 156, 203, 0.16);
        --wallet-chip-bg-hover: rgba(150, 156, 203, 0.28);
        --wallet-ring: rgba(150, 156, 203, 0.22);
        --wallet-track-bg: rgba(0, 0, 0, 0.25);
    }
}

.wallet-tabs {
    display: flex;
    gap: 4px;
    padding: 4px;
    margin-bottom: 1.25rem;
    background: var(--wallet-track-bg);
    border-radius: 10px;
}

.wallet-tab {
    flex: 1;
    padding: 9px 12px;
    border: none;
    border-radius: 7px;
    background: transparent;
    color: var(--wallet-muted);
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;
    transition: background 0.18s ease, color 0.18s ease;

    &:hover:not(.wallet-tab--active) {
        color: var(--color-primary_01);
    }

    &--active {
        background: var(--white_01, #fff);
        color: var(--color-primary_01);
        font-weight: 700;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
        cursor: default;
    }
}

// Header block: icon + stacked title/subtitle, vertically centered as a unit.
.wallet-header-icon {
    width: 40px;
    height: 40px;
    flex-shrink: 0;
}

.wallet-header-text {
    display: flex;
    flex-direction: column;
    justify-content: center;
    // Tight optical gap between the two lines; no outer margins so the block
    // centers cleanly against the 40px icon.
    gap: 1px;

    // Title and subtitle share one baseline grid inside the header — strip the
    // Bootstrap <label> defaults (margin/padding) that were pushing them around.
    .deposit-label-1,
    .deposit-label-2 {
        margin: 0;
        padding: 0;
    }
}

.deposit-label-1{
    display: block;
    font-size: 18px;
    // Roboto Slab only ships 300/400/700 — 500/600 were faux-bolded.
    font-weight: 700;
    line-height: 1.2;
    color: var(--color-primary_01);
    margin-bottom: 0;
}

.deposit-label-2{
    font-size: 12px;
    font-weight: 400;
    line-height: 1.2;
    color: var(--wallet-muted);
    margin-bottom: 6px;
}

.logosCoin {
  width: 16px;
}

.bitcoinIcon {
    font-size: 16px;
}

.icons-container-aligment{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: end;
}

.icons-container-aligment-item{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

.deposit-button-container{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

.deposit-button {
    width: 100%;
    border: none;
    border-radius: 12px;
    padding: 14px 20px;
    background: linear-gradient(160deg, var(--wallet-accent) 0%, var(--wallet-accent-deep) 100%);
    color: white;
    font-weight: 700;
    font-size: 15px;
    letter-spacing: 0.01em;
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;
    box-shadow: 0 4px 12px rgba(38, 44, 102, 0.22);
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        transform: translateY(-1px);
        box-shadow: 0 6px 16px rgba(38, 44, 102, 0.3);
        filter: brightness(1.06);
    }

    &:active {
        transform: translateY(0);
        box-shadow: 0 2px 8px rgba(38, 44, 102, 0.22);
    }
}

.input-with-prefix {
    position: relative;
    display: flex;
    align-items: center;
}

.input-prefix {
    position: absolute;
    left: 14px;
    color: var(--wallet-muted);
    font-size: 15px;
    font-weight: 400;
    pointer-events: none;
    z-index: 1;
}

.deposit-input {
    width: 100%;
    border: 1px solid var(--grey-1200-1);
    border-radius: 10px;
    padding: 13px 16px;
    background: var(--white_01);
    color: var(--color-primary_01);
    font-size: 16px;
    font-weight: 400;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;

    &::placeholder {
        color: var(--grey-2200);
        font-weight: 400;
    }

    &:focus {
        outline: none;
        border-color: var(--wallet-accent-soft);
        box-shadow: 0 0 0 3px var(--wallet-ring);
    }

    // Amount: prominent numerals, no native spinner arrows.
    &[type='number'] {
        font-size: 17px;
        font-weight: 700;
        appearance: textfield;
        -moz-appearance: textfield;

        &::-webkit-inner-spin-button,
        &::-webkit-outer-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }
    }

    &--with-prefix {
        padding-left: 30px;
    }
}

.deposit-info-box {
    background: rgba(52, 59, 134, 0.05);
    border: 1px solid rgba(52, 59, 134, 0.12);
    border-radius: 12px;
    padding: 14px 18px;

    [theme='night'] & {
        background: rgba(150, 156, 203, 0.08);
        border-color: rgba(150, 156, 203, 0.22);
    }
}

.deposit-info-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 5px 0;
    color: var(--wallet-text-soft);
    font-size: 12.5px;
    font-weight: 400;

    &:first-child {
        padding-top: 0;
    }

    &:last-child {
        padding-bottom: 0;
    }
}

.deposit-info-icon {
    font-size: 14px;

    &--success {
        color: #10b981;
    }

    &--secure {
        color: var(--wallet-accent-soft);
    }
}

.dropdown-wrapper {
    position: relative;
}

.dropdown {
    width: 100%;
    background: var(--white_01);
    background-image: none !important;
    border: 1px solid var(--grey-1200-1);
    border-radius: 10px;
    padding: 10px 14px;
    cursor: pointer;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;

    &:hover {
        border-color: var(--wallet-accent-soft);
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
}

.dropdown-open {
    border-color: var(--wallet-accent-soft);
    box-shadow: 0 0 0 3px var(--wallet-ring);
    background: var(--white_01);
}

.dropdown-button {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    text-decoration: none;
    color: var(--color-primary_01);
}

.dropdown-selected {
    display: flex;
    align-items: center;
    gap: 10px;
    font-weight: 400;
}

.dropdown-icon {
    width: 20px;
    height: 20px;
}

.dropdown-chevron {
    font-size: 12px;
    color: var(--grey-2200);
    transition: transform 0.2s ease;
}

.chevron-up {
    transform: rotate(180deg);
}

.dropdown-content {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    right: 0;
    background-color: var(--white_01);
    border: 1px solid var(--grey-1200-1);
    border-radius: 10px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
    z-index: 100;
    overflow: hidden;
}

.dropdown-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 14px;
    color: var(--color-primary_01);
    text-decoration: none;
    cursor: pointer;
    transition: background-color 0.15s ease;

    &:hover {
        background-color: var(--wallet-chip-bg);
    }
}

.dropdown-item-selected {
    background-color: var(--wallet-chip-bg);
    font-weight: 700;

    &:hover {
        background-color: var(--wallet-chip-bg);
    }
}

// Dropdown fade transition
.dropdown-fade-enter-active,
.dropdown-fade-leave-active {
    transition: all 0.15s ease;
}

.dropdown-fade-enter-from,
.dropdown-fade-leave-to {
    opacity: 0;
    transform: translateY(-8px);
}

.text-alignment {
    align-content: center;
}

.address-input {
    width: 100%;
    border: 1px solid var(--grey-1200-1);
    border-radius: 10px;
    padding: 12px 16px;
    background: var(--white_01);
    color: var(--color-primary_01);
    font-size: 13px;
    font-family: monospace;
}

.click-to-copy-hint {
    font-size: 11px;
    color: var(--grey-2200);
    font-weight: 400;
    margin-left: 4px;
}

.deposit-amount-highlight {
    font-weight: 700;
    color: #10b981;
    font-size: 13px;
}

.address-copyable {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    padding: 16px 18px;
    background: var(--wallet-chip-bg);
    border: 2px dashed var(--wallet-accent-soft);
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        background: var(--wallet-chip-bg-hover);
        border-style: solid;
        border-color: var(--wallet-accent-soft);
        
        .address-copy-icon {
            color: var(--color-primary_05);
            transform: scale(1.15);
        }
    }
    
    &:active {
        transform: scale(0.99);
    }
    
    [theme='night'] & {
        background: linear-gradient(135deg, rgba(150, 156, 203, 0.12) 0%, rgba(134, 144, 219, 0.18) 100%);
        border-color: rgba(150, 156, 203, 0.4);
        
        &:hover {
            background: linear-gradient(135deg, rgba(150, 156, 203, 0.2) 0%, rgba(134, 144, 219, 0.25) 100%);
            border-color: rgba(150, 156, 203, 0.6);
        }
    }
}

.address-text {
    // 'Roboto Mono' isn't loaded by the app — use a clean system mono stack.
    font-family: ui-monospace, 'SF Mono', Menlo, Consolas, monospace;
    font-size: 14px;
    font-weight: 500;
    color: var(--color-primary_01);
    word-break: break-all;
    flex: 1;
    line-height: 1.5;
    letter-spacing: 0.3px;
}

.address-copy-icon {
    font-size: 18px;
    color: var(--color-primary_05);
    transition: all 0.2s ease;
    flex-shrink: 0;
    opacity: 0.8;
}

.cancel-button {
    width: 100%;
    border: none;
    border-radius: 10px;
    padding: 12px 16px;
    background: rgba(239, 68, 68, 0.15);
    color: #ef4444;
    font-weight: 500;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:hover {
        background: rgba(239, 68, 68, 0.25);
    }
}

.sent-button {
    width: 100%;
    border: none;
    border-radius: 10px;
    padding: 12px 16px;
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    color: white;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    
    &:hover:not(:disabled) {
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(16, 185, 129, 0.4);
    }
    
    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
        background: #6b7280;
        box-shadow: none;
    }
}

.qrcode-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
}

.qrcode-wrapper {
    background: white;
    padding: 12px;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.qrcode-hint {
    font-size: 12px;
    color: var(--grey-2200);
    margin: 0;
    text-align: center;
}

.pending-value-display {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 14px 16px;
    background: var(--white_01);
    border: 1px solid var(--grey-1200-1);
    border-radius: 10px;
}

.pending-value-prefix {
    font-size: 18px;
    font-weight: 600;
    color: #10b981;
}

.pending-value-amount {
    font-size: 18px;
    font-weight: 600;
    color: var(--color-primary_01);
}

.request-method-button {
    width: 100%;
    border: 1px solid var(--color-primary_05);
    border-radius: 12px;
    padding: 12px 20px;
    background: transparent;
    color: var(--color-primary_01);
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 12px;

    &:hover {
        background: var(--grey-1600);
        border-color: var(--color-primary_01);
    }
}

.request-method-form {
    margin-top: 12px;
}

.request-send-button {
    padding: 12px 20px;
    font-size: 14px;

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
        transform: none;
    }
}

.request-form-cancel {
    display: block;
    text-align: center;
    margin-top: 10px;
    font-size: 12px;
    color: var(--grey-2200);
    cursor: pointer;

    &:hover {
        color: var(--color-primary_01);
    }
}

.request-sent-state {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    text-align: left;

    .request-sent-title {
        display: block;
        font-weight: 600;
    }

    .request-sent-detail {
        display: block;
        font-size: 12px;
        font-weight: 500;
        opacity: 0.85;
    }
    margin-top: 12px;
    padding: 12px 20px;
    border-radius: 12px;
    font-size: 13px;
    font-weight: 600;
    color: #10b981;
    background: rgba(16, 185, 129, 0.08);
    border: 1px solid rgba(16, 185, 129, 0.25);
}
</style>
  